/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create and rename a condition. Its tree is written through the tree endpoint.
 * @export
 * @interface PatchedConditionWriteRequest
 */
export interface PatchedConditionWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedConditionWriteRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedConditionWriteRequest
     */
    workflow?: string;
}

/**
 * Check if a given object implements the PatchedConditionWriteRequest interface.
 */
export function instanceOfPatchedConditionWriteRequest(value: object): value is PatchedConditionWriteRequest {
    return true;
}

export function PatchedConditionWriteRequestFromJSON(json: any): PatchedConditionWriteRequest {
    return PatchedConditionWriteRequestFromJSONTyped(json, false);
}

export function PatchedConditionWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedConditionWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'workflow': json['workflow'] == null ? undefined : json['workflow'],
    };
}

export function PatchedConditionWriteRequestToJSON(json: any): PatchedConditionWriteRequest {
    return PatchedConditionWriteRequestToJSONTyped(json, false);
}

export function PatchedConditionWriteRequestToJSONTyped(value?: PatchedConditionWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'workflow': value['workflow'],
    };
}

